import { normalizeMap } from '@/libs/form-translations/normalize'

/**
 * Transform the translations for the form usage.
 * Keys are normalized (`<br/>` -> `<br>`) so legacy keys merge with their
 * sanitized twin.
 *
 * @param {Object} translations
 *
 * @returns {Object}
 */
const transformForForm = translations => {
  const result = {}

  Object.keys(translations || {}).forEach(lang => {
    const map = normalizeMap(translations[lang])
    const keys = Object.keys(map).sort((a, b) => a.localeCompare(b))

    result[lang] = keys.map(key => ({
      key,
      value: map[key],
    }))
  })

  return result
}

/**
 * Transforms the translations to the desired store format
 * (`{ lang: { key: value } }`, keys normalized).
 *
 * @param {Object} translations `{ lang: [{ key, value }] }`
 *
 * @returns {Object}
 */
const transformForStorage = translations => {
  const data = {}

  Object.entries(translations || {}).forEach(([language, items]) => {
    data[language] = normalizeMap((items || []).reduce((acc, curr) => {
      acc[curr.key] = curr.value

      return acc
    }, {}))
  })

  return data
}

export {
  transformForForm,
  transformForStorage,
}
